import React from 'react';
import { motion } from 'framer-motion';
import { Search, Shield, LayoutTemplate } from 'lucide-react';
import { SectionHeading } from './Shared';
const benefits = [{
  icon: <Search className="w-8 h-8 text-gold" data-id="element-13" />,
  title: 'MÁS CLARIDAD PARA DETECTAR EL PROBLEMA',
  description: 'Vas a saber qué evaluar cuando el paciente dice “duermo mal”, cómo diferenciar tipos de insomnio, qué factores lo desencadenan y qué conductas lo mantienen.'
}, {
  icon: <Shield className="w-8 h-8 text-gold" data-id="element-14" />,
  title: 'MÁS SEGURIDAD PARA INTERVENIR',
  description: 'Vas a contar con técnicas cognitivas, conductuales y psicoeducativas para trabajar el insomnio sin reducirlo solo a higiene del sueño.'
}, {
  icon: <LayoutTemplate className="w-8 h-8 text-gold" data-id="element-15" />,
  title: 'MÁS ESTRUCTURA PARA ACOMPAÑAR EL PROCESO',
  description: 'No es teoría abstracta. Son guías, preguntas, plantillas y recursos prácticos para aplicar dentro del tratamiento psicológico real.'
}];
export function Benefits() {
  return <section className="py-20 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-18">
          <SectionHeading data-id="element-19">
            UN SISTEMA PARA TRABAJAR EL INSOMNIO CON MÁS ORDEN CLÍNICO
          </SectionHeading>
          <p className="text-lg text-slate-600" data-id="element-20">
            Creamos un sistema claro y aplicable para que dejes de abordar el
            insomnio con recomendaciones sueltas, consejos generales o
            improvisación clínica… y empieces a detectar, conceptualizar,
            intervenir y acompañar el sueño del paciente con una estructura
            profesional.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-22">
              <div className="w-16 h-16 bg-white rounded-xl shadow-sm flex items-center justify-center mb-6 border border-slate-100" data-id="element-23">
                {benefit.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-navy mb-4 leading-snug" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-25">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}